window.addEventListener('load', function () {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    document.querySelectorAll('.gsap-fade-up, .gsap-stagger-children > *').forEach(function (el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
    });
    return;
  }

  /*
    Single element animation
    Usage:
    <section class="gsap-trigger">
      <h2 class="gsap-fade-up">Heading</h2>
    </section>
  */
document.querySelectorAll('.gsap-trigger').forEach(function (trigger) {
  const fadeUpElements = Array.from(trigger.querySelectorAll('.gsap-fade-up'));

  if (!fadeUpElements.length) return;

  gsap.fromTo(
    fadeUpElements,
    {
      opacity: 0,
      y: 40
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: 'power2.out',
      stagger: 0.2,
      scrollTrigger: {
        trigger: trigger,
        start: 'top 80%',
        once: true
      }
    }
  );
});

  /*
    Stagger children animation
    Usage:
    <section class="gsap-trigger">
      <div class="gsap-stagger-children">
        <div>Child 1</div>
        <div>Child 2</div>
        <div>Child 3</div>
      </div>
    </section>
  */
  document.querySelectorAll('.gsap-trigger .gsap-stagger-children').forEach(function (parent) {
    const trigger = parent.closest('.gsap-trigger') || parent;
    const children = Array.from(parent.children);

    if (!children.length) return;

    gsap.fromTo(
      children,
      {
        opacity: 0,
        y: 40
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.75,
        ease: 'power2.out',
        stagger: 0.12,
        scrollTrigger: {
          trigger: trigger,
          start: 'top 80%',
          once: true
        }
      }
    );
  });
});